/*
 * File: cell-account-provider.ts
 * Created: 2025-12-11 07:02:45
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2025-12-11 07:02:54
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

import { Component } from "vue-property-decorator";
// 假設 BaseTableBodyCell 的路徑
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";
import { UITag } from "@root/core/tags";

@Component
@UITag.setDefault({
    uiAlign: "l", // Provider 通常靠左對齊比較好看
})
export default class CellAccountProvider extends BaseTableBodyCell {
    // 獲取 Provider Key
    get providerKey(): string {
        // 假設 value 直接就是 provider string (例如 "google")
        return this.value || "credentials";
    }

    // 獲取顯示文字 (透過 i18n)
    get providerLabel(): string {
        const key = this.providerKey;
        // 從全域 enum 獲取翻譯鍵值
        const translationKey = (window as any).enums().EAccountProvider[key];
        return translationKey ? this.$_(translationKey) : key;
    }

    // 獲取 Icon Class
    get iconClass(): string {
        const key = this.providerKey;
        switch (key) {
            case "google":
                return "fab fa-google text-danger";
            case "ldap":
                return "fas fa-sitemap text-warning";
            case "credentials":
            default:
                // 使用 database 代表本機/憑證
                return "fas fa-database text-info";
        }
    }
}
